/** Paths that render before the signed-in shell chunk is downloaded. */
const PUBLIC_EXACT_PATHS: ReadonlySet<string> = new Set([
  "/login",
  "/free-trial",
  "/try",
  "/register",
  "/sign-up",
  "/accept-invitation",
  "/choose-organization",
  "/pricing",
  "/privacy-notice",
  "/cookie-policy",
  "/terms-of-use",
  "/subject-access-request",
  "/api-docs",
]);

/** True for auth, legal, and other pages that must paint without the app shell. */
export function isPublicAppPath(location: string): boolean {
  const path = location.split("?")[0]?.split("#")[0] ?? "/";
  if (path.startsWith("/report-incident")) {
    return true;
  }
  return PUBLIC_EXACT_PATHS.has(path);
}
